import { render, staticRenderFns } from "./IndentDetail.vue?vue&type=template&id=73161aaa&scoped=true"
import script from "./IndentDetail.vue?vue&type=script&lang=js"
export * from "./IndentDetail.vue?vue&type=script&lang=js"
import style0 from "./IndentDetail.vue?vue&type=style&index=0&id=73161aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73161aaa",
  null
  
)

export default component.exports